// extracted by mini-css-extract-plugin
export default {"imageContainer":"u0-z","summaryPar":"v0-z","ratingCategories":"w0-z","reviewerInfo":"x0-z","reviewTypes":"y0-z","expanded":"z0-z"};